const rating = () => {
	const ratings = document.querySelectorAll('.js-rating');

	ratings.forEach(rating => {
		const starRating = new StarRating(rating, {
			maxStars: 5,
			classNames: {
				active: "rating__active",
				base: "rating",
				selected: "rating__selected",
			},
			tooltip: false,
		});
	})
}
